module.exports = __webpack_public_path__ + "img/user.522f6351.svg";